// Rótulos PT-BR e formatadores do Controle de Caixas (compartilhados entre as telas). Material/tipo são
// dinâmicos (catálogo): o rótulo usa os NOMES que o backend entrega (congelados nos lançamentos).
import type {
  BoxMovementStatus,
  BoxOperation,
  BoxPaymentMethod,
} from "@/lib/boxControlApi";

const SP_ZONE = "America/Sao_Paulo";

export const OPERATION_LABEL: Record<BoxOperation, string> = {
  EMPRESTIMO: "Empréstimo",
  VENDA: "Venda",
};

export const STATUS_LABEL: Record<BoxMovementStatus, string> = {
  PENDENTE: "Pendente",
  PARCIALMENTE_DEVOLVIDO: "Parcialmente devolvido",
  DEVOLVIDO: "Devolvido",
  PARCIALMENTE_PAGO: "Parcialmente pago",
  PAGO: "Pago",
  ESTORNADO: "Estornado",
};

export const PAYMENT_METHOD_LABEL: Record<BoxPaymentMethod, string> = {
  DINHEIRO: "Dinheiro",
  PIX: "Pix",
  CARTAO: "Cartão",
  TRANSFERENCIA: "Transferência",
  OUTRO: "Outro",
};

export const PAYMENT_METHODS: BoxPaymentMethod[] = ["DINHEIRO", "PIX", "CARTAO", "TRANSFERENCIA", "OUTRO"];

/** Rótulo "Material — Tipo" a partir dos nomes (o tipo pode ser nulo para material sem subdivisão). */
export function materialTypeLabel(materialName: string, typeName: string | null | undefined): string {
  return typeName ? `${materialName} — ${typeName}` : materialName;
}

export function formatMoney(value: number | null | undefined): string {
  if (value === null || value === undefined) return "—";
  return value.toLocaleString("pt-BR", { style: "currency", currency: "BRL" });
}

/** Data (yyyy-mm-dd ISO) → dd/MM/yyyy. */
export function formatDate(iso: string | null | undefined): string {
  if (!iso) return "—";
  const [y, m, d] = iso.slice(0, 10).split("-");
  return d && m && y ? `${d}/${m}/${y}` : iso;
}

/** Instante ISO → dd/MM/yyyy HH:mm no fuso de Brasília. */
export function formatDateTimeBrasilia(iso: string | null | undefined): string {
  if (!iso) return "—";
  const date = new Date(iso);
  if (Number.isNaN(date.getTime())) return iso;
  return new Intl.DateTimeFormat("pt-BR", {
    timeZone: SP_ZONE,
    day: "2-digit",
    month: "2-digit",
    year: "numeric",
    hour: "2-digit",
    minute: "2-digit",
  }).format(date);
}

/** Data de hoje (yyyy-mm-dd) no fuso de Brasília — default do campo de data da operação. */
export function todayInBrasilia(): string {
  const parts = new Intl.DateTimeFormat("en-CA", {
    timeZone: SP_ZONE,
    year: "numeric",
    month: "2-digit",
    day: "2-digit",
  }).format(new Date());
  return parts; // en-CA já retorna yyyy-mm-dd
}
